import { CSSProperties } from 'react'
import prefectureMap from 'utils/prefecture-map'
import { Select } from 'antd'
import { Form } from 'components/common'

export interface PrefectureSelectProps {
  required: boolean
  defaultValue?: string
  style?: CSSProperties
}

const options = Object.entries(prefectureMap).map(([key, value]) => (
  <Select.Option key={key} value={key}>
    {value}
  </Select.Option>
))

export const SelectPrefecture = ({
  required,
  defaultValue,
  style,
}: PrefectureSelectProps): JSX.Element => {
  return (
    <>
      <Form.Item
        name={'prefectureCode'}
        label="都道府県"
        labelCol={{ span: 24 }}
        initialValue={defaultValue}
        rules={[{ required }]}
        style={style}
      >
        <Select placeholder="選択してください">{options}</Select>
      </Form.Item>
    </>
  )
}
